<template>
  <div>

    <b-modal
      id="modal-medicine"
      size="xl"
      modal-class="medhop-lookup-modal medhop-medicine-modal"
      body-class="medhop-lookup-modal__body"
      hide-header
      hide-footer
    >
      <header class="medhop-lookup-modal__header">
        <span class="medhop-lookup-modal__icon"><i class="fas fa-pills"></i></span>
        <div><h2>Pilih obat dan alat kesehatan</h2><p>Pilih satu atau beberapa item untuk dimasukkan ke transaksi.</p></div>
        <button type="button" class="medhop-lookup-modal__close" aria-label="Tutup" @click="$bvModal.hide('modal-medicine')"><i class="fas fa-times"></i></button>
      </header>
      <Table
        purpose="modal"
        modalPurpose="modal"
        :isHospitalTransaction="isHospitalTransaction"
        :selectedItem="selectedItem"
        :checkbox="checkbox"
        :isSortcut="isSortcut"
        :isAbjad="isAbjad"
        @chooseMedicine="chosenMedicine"
        @packageMedicine="packageMedicine"
        :secondPurpose="secondPurpose"
      />
    </b-modal>

  </div>
</template>

<script>

import Table from '@/component/medicine/TablePayment.vue'

export default {

  props: {
    selectedItem: Array,
    checkbox: Boolean,
    isHospitalTransaction: Boolean,
    isSortcut: Boolean,
    isAbjad: Boolean,
    secondPurpose: {
      type: String,
      default: 'listing'
    }
  },

  components: {
    Table
  },

  methods: {

    chosenMedicine(value, e) {
      this.$emit('chosenMedicine', value, e)
    },

    packageMedicine(datas) {
      this.$emit("packageMedicine", datas);
    },

  },
  mounted() {
  }

}
</script>

<style>
</style>
